<header class="header">
  @let logoConfig = logoConfig$ | async;
  <a class="header__logo" routerLink="/">
    <img
      alt="Organization Logo"
      class="logo-image"
      [class]="{ 'is-circle': logoConfig.logoFormType === CROPPER_MODES.CIRCLE }"
      [src]="logoConfig.imageConfig.imageFile"
    />
  </a>
</header>
